export default "__VITE_ASSET__a3a51582__$_?component__"